import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ImageUploader from './ImageUploader';
import MessageInput from './MessageInput';
import { playClick } from '../utils/sound';

const TILE_COUNT = 6;

const Home = ({
  image, setImage,
  message, setMessage,
  gridSize, setGridSize,
  fontStyle, setFontStyle
}) => {
  const navigate = useNavigate();
  const [tiles, setTiles] = useState([]);

  const handlePreview = () => {
    if (!image || !message) {
      alert('Please upload an image and enter a message.');
      return;
    }
    navigate('/puzzle');
  };

  function shuffleArray(array) {
    return array
      .map(value => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  }

  useEffect(() => {
    const img = new Image();
    img.src = process.env.PUBLIC_URL + '/assets/background.jpg';
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const tileWidth = img.width / TILE_COUNT;
      const tileHeight = img.height / TILE_COUNT;

      const newTiles = [];

      for (let row = 0; row < TILE_COUNT; row++) {
        for (let col = 0; col < TILE_COUNT; col++) {
          canvas.width = tileWidth;
          canvas.height = tileHeight;
          ctx.clearRect(0, 0, tileWidth, tileHeight);
          ctx.drawImage(
            img,
            col * tileWidth, row * tileHeight,
            tileWidth, tileHeight,
            0, 0,
            tileWidth, tileHeight
          );
          const dataUrl = canvas.toDataURL();
          newTiles.push(dataUrl);
        }
      }

      setTiles(shuffleArray(newTiles));
    };
  }, []);

  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'grid',
        gridTemplateColumns: `repeat(${TILE_COUNT}, 1fr)`,
        gridTemplateRows: `repeat(${TILE_COUNT}, 1fr)`,
        zIndex: -1
      }}>
        {tiles.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: 0.5,
              filter: 'blur(1px)'
            }}
          />
        ))}
      </div>

      <div
        style={{
          padding: '2rem',
          textAlign: 'center',
          position: 'relative',
          zIndex: 1,
          background: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(2px)',
          borderRadius: '12px',
          margin: '2rem auto',
          maxWidth: '720px'
        }}
      >
        <h1>
          Create Your Puzzle <span role="img" aria-label="gift-puzzle">🎁🧩</span>
        </h1>

        <div style={{ margin: '2rem auto', textAlign: 'left', maxWidth: '500px' }}>
          <h2 style={{ textAlign: 'center' }}>Puzzle Creation Steps</h2>
          <ol style={{ lineHeight: '1.6', fontSize: '1rem' }}>
            <li>Agree to the Terms and Conditions.</li>
            <li>Select Your Image.</li>
            <li>Add Your Message.</li>
            <li>Select Your Puzzle Difficulty</li>
            <li>Select Your Message Font</li>
            <li>Preview Your Puzzle.</li>
            <li>Share your Puzzle!</li>
          </ol>
        </div>

        <ImageUploader onImageSelect={setImage} />
        <MessageInput message={message} setMessage={setMessage} />

        <div style={{ marginTop: '1rem' }}>
          <h3>Select Puzzle Difficulty</h3>
          <select value={gridSize} onChange={(e) => setGridSize(Number(e.target.value))}>
            <option value={3}>Easy (3x3)</option>
            <option value={4}>Medium (4x4)</option>
            <option value={5}>Hard (5x5)</option>
            <option value={10}>Extreme (10x10)</option>
          </select>
        </div>

        <div style={{ marginTop: '1rem' }}>
          <h3>Select Font Style</h3>

<select value={fontStyle} onChange={(e) => setFontStyle(e.target.value)}>
  {/* Existing choices */}
  <option value="serif">Serif (classic)</option>
  <option value="sans-serif">Sans-serif (clean)</option>
  <option value="cursive">Cursive (fancy)</option>
  <option value="monospace">Monospace (typewriter)</option>
  {/* New elegant / festive choices */}
  <option value="'Garamond', serif">Garamond (elegant)</option>
  <option value="'Palatino Linotype', 'Palatino', serif">Palatino (formal)</option>
  <option value="'Brush Script MT', cursive">Brush Script (hand-written)</option>
  <option value="'Comic Sans MS', cursive">Comic Sans (playful)</option>
  <option value="'Impact', Charcoal, sans-serif">Impact (bold)</option>
  <option value="'Trebuchet MS', sans-serif">Trebuchet MS (modern)</option>
</select>
        </div>

        <button
          onClick={() => {
            playClick();
            handlePreview();
          }}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1rem',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            transition: 'transform 0.1s ease',
          }}
          onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
          onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          Puzzle Preview
        </button>
      </div>
    </>
  );
};

export default Home;
